
import Selector from 'vux/src/components/selector/index.vue'
import Card from 'vux/src/components/card/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XAddress from 'vux/src/components/x-address/index.vue'
import Panel from 'vux/src/components/panel/index.vue'
import Radio from 'vux/src/components/radio/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'

export default {
components: {
XInput,
Group,
XAddress,
Card,
Cell,
Selector,
Panel,
Radio,
XButton,
CellBox
},
data (){
return {
fdesc:'',
ftype:'硬件问题',
subClass1:'设备启动故障',
subClass2:'无法开机',
selisShow: true,
flag:true,
inputisShow:false,
list1:['硬件问题', '软件问题', '运输问题', '其他问题'],
list2:['设备启动故障', '设备死机故障', '设备显示故障', '设备识别故障', '设备输入输出故障', '设备音频故障','其他问题'],
list3:['无法开机', '无法显示', '无法自动重启', '无法进入操作系统','开机自动断电','其他问题'],
obj:{
ftype:'',
fdesc:""
},
lastflag:true
}
},
methods:{
confirm(){
var that = this
if(this.selisShow){
this.obj.ftype = this.ftype + ',' + this.subClass1
localStorage.setItem('ftype',this.ftype)
localStorage.setItem('subClass1',this.subClass1)
}
else {
this.obj.ftype = this.ftype
localStorage.setItem('ftype',this.ftype)
localStorage.setItem('subClass1','')
}
if(this.flag){
this.obj.fdesc = this.subClass2
localStorage.setItem('subClass2',this.subClass2)
}
else {
this.obj.fdesc = this.fdesc
localStorage.setItem('fdesc',this.fdesc)
localStorage.setItem('subClass2','')
}
this.$router.push({name:'rapidrepairs',params:{obj:this.obj}})
},
superclassChange (val) {
switch (val) {
case '硬件问题':
this.list2 = ['设备启动故障', '设备死机故障', '设备显示故障', '设备识别故障', '设备输入输出故障', '设备音频故障','其他问题']
this.subClass1 = this.lastflag ? '设备启动故障' : this.subClass1
this.selisShow = true
this.flag = true
this.inputisShow = false
this.lastflag = true
break
case '软件问题':
this.list3 = ['无法登陆管理界面', '无法修改配置','客户端无法挂载','存储无法访问','非编回放/采集丢帧/彩条','存储性能不佳','数据丢失','数据无法读写','其他问题']
this.subClass2 = this.lastflag ? '无法登陆管理界面' : this.subClass2
this.selisShow = false
this.flag = true
this.inputisShow = false
this.lastflag = true
break
case '运输问题':
this.list3 = ['机箱变形','元器件脱落','机箱内有异物','前面板脱落','其他问题']
this.subClass2 = this.lastflag ? '机箱变形' : this.subClass2
this.selisShow = false
this.flag = true
this.inputisShow = false
this.lastflag = true
break
case '其他问题':
this.list3 = ['物理损伤', '按键失灵', '机内有异响', '板载接口故障','板载插槽故障','其他问题']
this.subClass2 = this.lastflag ? '物理损伤' : this.subClass2
this.selisShow = false
this.lastflag = true
break
default:
break
}
},
superclassChange1(val){
switch (val){
case '设备启动故障':
this.list3 = ['无法开机', '无法显示', '无法自动重启', '无法进入操作系统','开机自动断电','其他问题']
this.subClass2 = this.lastflag ? '无法开机' : this.subClass2
this.lastflag = true
break
case '设备死机故障':
this.list3 = ['开机自检死机', '进入操作系统死机', '复制文件死机', '运行软件死机','蓝屏死机','其他问题']
this.subClass2 = this.lastflag ? '开机自检死机' : this.subClass2
this.lastflag = true
break
case '设备显示故障':
this.list3 = ['开机花屏', '显示偏色', '进入操作系统花屏', '显示马赛克','其他问题']
this.subClass2 = this.lastflag ? '开机花屏' : this.subClass2
this.lastflag = true
break
case '设备识别故障':
this.list3 = ['板卡无法识别', 'USB无法识别', '硬盘无法识别', 'RAID卡无法识别','光驱无法识别','其他问题']
this.subClass2 = this.lastflag ? '板卡无法识别' : this.subClass2
this.lastflag = true
break
case '设备输入输出故障':
this.list3 = ['显卡无输出', 'SDI无输入输出', 'CVBS无输出', 'HDMI无输入输出','输入绿屏','其他问题']
this.subClass2 = this.lastflag ? '显卡无输出' : this.subClass2
this.lastflag = true
break
case '设备音频故障':
this.list3 = ['板卡音频无输出', '板卡音频无输入', '音频输出单声道', '板载音频无输出','其他问题']
this.subClass2 = this.lastflag ? '板卡音频无输出' : this.subClass2
this.lastflag = true
break
case '其他问题':
this.list3 = ['物理损伤', '按键失灵', '机内有异响', '板载接口故障','板载插槽故障','其他问题']
this.subClass2 = this.lastflag ? '物理损伤' : this.subClass2
this.lastflag = true
this.selisShow = false
break
default:
break
}
},
superclassChange2(val){
switch (val){
case '其他问题':
this.flag = false
this.inputisShow = true
break
default:
this.flag = true
this.inputisShow = false
break
}
}
},
beforeRouteEnter (to, from, next){
if(from.name == 'rapidrepairs'){
next(vm => {

var fault = localStorage.getItem('fault')
var obj = JSON.parse(fault)
vm.obj = obj
if(obj.ftype){

var ftype = localStorage.getItem('ftype')
var subClass1 = localStorage.getItem('subClass1')
var subClass2 = localStorage.getItem('subClass2')
var fdesc = localStorage.getItem('fdesc')
vm.lastflag = false
vm.ftype = ftype
if(subClass1){
vm.subClass1 = subClass1
}
else {
vm.subClass1 = ''
vm.selisShow = false
}
if(subClass2){
vm.subClass2 = subClass2
}
else {
vm.subClass2 = '其他问题'
vm.fdesc = fdesc
}
}
localStorage.setItem('obj',JSON.stringify(obj))
console.log(obj)
})
}
else {
next(vm => {
var obj = localStorage.getItem('obj')
vm.obj = JSON.parse(obj)
console.log(vm.obj)
})
}
},
beforeRouteLeave(to, from, next){
if(to.name == 'photo'){
next()
}



next()
}
}



// WEBPACK FOOTER //
// ./src/components/faultType1.vue